/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'company-hub.spotlight-extension.config-panel.preamble':
    '重要なメッセージを視覚に訴えるスポットライトで強調します。{supportLink}',
  'company-hub.spotlight-extension.config-panel.preamble-link.label': 'スポットライトの詳細',
  'company-hub.spotlight-extension.config-panel.preamble-without-support-link':
    '重要なメッセージを視覚に訴えるスポットライトで強調します。',
  'company-hub.spotlight-extension.config-panel.title': 'スポットライト',
  'company-hub.spotlight-extension.hub-element.description': '重要なメッセージを強調',
  'company-hub.spotlight-extension.hub-element.title': 'スポットライト',
  'company-hub.spotlight-extension.manifest.initial-state.alt-image-text': '砂漠の風景写真',
  'company-hub.spotlight-extension.manifest.initial-state.text-description':
    '最も重要な情報を強調するスポットライトをデザインします。カスタム配色、効果的な画像、柔軟なレイアウトを使用して、重要なメッセージを際立たせましょう。',
  'company-hub.spotlight-extension.manifest.initial-state.text-title': 'スポットライトにタイトルを付ける',
  'company-hub.spotlight-extension.manifest.macro-description':
    '重要なメッセージを視覚に訴えるスポットライトで強調します。',
  'company-hub.spotlight-extension.manifest.macro-title': 'スポットライト',
  'company-hub.spotlight-extension.manifest.macro-title.new': 'スポットライト [新機能]',
  'company-hub.spotlight-extension.spotlight-config-panel.content-tab.label': 'コンテンツ',
  'company-hub.spotlight-extension.spotlight-config-panel.general-title': '全般',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts-title': 'レイアウト',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.frame-above-image.description':
    '大きな画像にテキスト ボックスを重ねて表示します',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.frame-above-image.label':
    '画像内のコンテンツ フレーム',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.image-background.description':
    'コンテンツの後景にフルサイズ画像',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.image-background.label': '画像の背景',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.solid-color-background.description':
    '全幅で色を敷き、その前景にコンテンツ',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.solid-color-background.label': '無地の背景',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-content-first.description':
    'コンテンツ用の領域を広く取って大きな画像を右側に配置',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-content-first.label':
    'スプリット デザイン (コンテンツが先)',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-image-first.description':
    'コンテンツ用の領域を広く取って大きな画像を左側に配置',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-image-first.label':
    'スプリット デザイン (画像が先)',
  'company-hub.spotlight-extension.spotlight-config-panel.styles-tab.label': 'スタイル',
  'company-hub.spotlight-extension.spotlight-config-panel.text-description-label': '説明',
  'company-hub.spotlight-extension.spotlight-config-panel.text-description-placeholder':
    'スポットライトはチームへの重要なメッセージを強調します。画像、カスタム配色、短い説明、リンクを使用して、スポットライトをデザインできます。',
  'company-hub.spotlight-extension.spotlight-config-panel.text-image-label': '画像',
  'company-hub.spotlight-extension.spotlight-config-panel.text-title-label': 'タイトル',
  'company-hub.spotlight-extension.spotlight-config-panel.text-title-placeholder': 'スポットライトにタイトルを付ける',
  'company-hub.spotlight-extension.spotlight.background.color': '背景色',
  'company-hub.spotlight-extension.spotlight.color-contrast.fail':
    '選択したテキストと背景の色は読みやすさの基準を満たしていません。',
  'company-hub.spotlight-extension.spotlight.color-contrast.success':
    '選択したテキストと背景の色は読みやすさの基準を満たしています。',
  'company-hub.spotlight-extension.spotlight.text.color': 'テキストの色',
};
